module.exports = __webpack_public_path__ + "static/dignitas-bold-fdd7f5ef5a92138efed252851f7e472b.woff2";